import PaidShareModal from './paid-share-modal';
export default PaidShareModal;
